import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../../data/painPoints';
export function PlanningProblem() {
  return <section aria-labelledby="problem-heading" className="bg-mint" data-id="element-165" data-mp="33zacn9935pjo">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-166" data-mp="2q73whn5xnik8">
        <h2 id="problem-heading" className="mx-auto max-w-4xl text-center font-display text-[2.5rem] font-extrabold uppercase leading-[0.95] text-forest sm:text-5xl md:text-6xl" data-id="element-167" data-mp="2v5f3zr8r9gza">
          If you teach HYROX classes, you are probably dealing with{' '}
          <span className="text-gold-dark" data-id="element-168" data-mp="3muh4i1xm11u3">at least one of these problems.</span>
        </h2>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-169" data-mp="38ywnjc1fytpb">
          {painPoints.map(({
          text
        }) => <li key={text} className="flex items-start gap-4 rounded-xl border border-forest/10 bg-white p-6 shadow-[0_2px_10px_-4px_rgba(9,40,29,0.12)]" data-id="element-170" data-mp="3dxpzh012ycnd">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-50" data-id="element-171" data-mp="22edmhjhlb9cl">
                <XIcon aria-hidden="true" className="h-5 w-5 text-red-500" strokeWidth={3} data-id="element-172" data-mp="ml664clcw527" />
              </span>
              <span className="text-lg font-medium leading-snug text-forest" data-id="element-173" data-mp="10knvat2kdkc3">{text}</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-3xl text-center font-display text-3xl font-extrabold uppercase leading-tight text-forest md:text-4xl" data-id="element-174" data-mp="vl2yao6yfm20">
          How many more weekends do you want to spend <span className="text-gold-dark" data-id="element-175" data-mp="15iz8nds2icz2">planning next week?</span>
        </p>
      </div>
    </section>;
}